import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://fd0fa04b03386315dc222b1f0eb56ecc@o4506249448194048.ingest.us.sentry.io/4506293368389632",
    beforeSend(event, hint) {
        // Check if it is an exception, and if so, show the report dialog
        if (event.exception && event.event_id) {
            Sentry.showReportDialog({ eventId: event.event_id });
        }
        return event;
    },
    // Safari's, Chrome's and Firefox's wording for a request the browser gave
    // up on: a content blocker stopping the Google Analytics beacon, a phone
    // losing signal. Nothing in this app to fix, and because beforeSend opens
    // the report dialog, each one showed families an error popup on My Account
    // for nothing (WHOA-JS-22). A server error does not reject fetch, so this
    // hides no response from our own app.
    ignoreErrors: [
        /^(TypeError: )?(Load failed|Failed to fetch|NetworkError when attempting to fetch resource\.)$/,
        // qr-scanner (packs/qr_scanner.js) throws this bare string, not an
        // Error, from its internal _getCameraStream() when
        // navigator.mediaDevices isn't available in the current browsing
        // context (e.g. a restricted in-app browser) -- nothing our own
        // .catch() handlers around start()/hasCamera() can act on
        // differently, and because beforeSend opens the report dialog, it
        // showed the person a popup for a page load they didn't cause
        // (WHOA-JS-2M). Sentry wraps a non-Error rejection's value as
        // "Non-Error promise rejection captured with value: <value>", so
        // this matches as a suffix rather than the whole message.
        /Camera not found\.$/,
    ],
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(
        {
            maskAllText: false,
            blockAllMedia: false
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

